import React from "react";
import { VegaButtonLink, VegaBox } from "@heartlandone/vega-react";
import { ROUTES_PATH } from "Chore/Constants";
import { useNavigate, useLocation } from "react-router-dom";

function ViewActivityAction({ activity }) {
  const { id } = activity;
  const navigate = useNavigate();
  const location = useLocation();

  const onViewDetialClick = () => {
    navigate(`${ROUTES_PATH.ACTIVITY_INFO}/${id}`, { state: { from: location.pathname + location.search } });
  };

  return (
    <VegaBox flexShrink={0} flexGrow={0}>
      <VegaButtonLink
        label="View Activity Details"
        icon="far fa-eye"
        onVegaClick={() => onViewDetialClick()}
      />
    </VegaBox>
  );
}

export default ViewActivityAction;
